import { render, staticRenderFns } from "./StoreAuxiliaryImport.vue?vue&type=template&id=20a0c5ea&scoped=true"
import script from "./StoreAuxiliaryImport.vue?vue&type=script&lang=js"
export * from "./StoreAuxiliaryImport.vue?vue&type=script&lang=js"
import style0 from "./StoreAuxiliaryImport.vue?vue&type=style&index=0&id=20a0c5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0c5ea",
  null
  
)

export default component.exports